import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface ProtectedRouteProps {
  publicRoute?: boolean; // Optional prop to handle public routes
  children?: JSX.Element; // Add children prop
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ publicRoute, children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Redirect authenticated users away from the sign-in page
  if (isAuthenticated && location.pathname === "/authentication/sign-in") {
    return <Navigate to="/" />;
  }

  // If the route is public and the user is authenticated, redirect to the dashboard
  if (publicRoute && isAuthenticated) {
    return <Navigate to="/" />;
  }

  // Render children if authenticated or allow access to the sign-in page
  return isAuthenticated ? <Outlet /> : children ? children : <Navigate to="/authentication/sign-in" />;
};

export default ProtectedRoute;
